import { Center, Input, type InputWrapperProps, Loader, Paper, Tabs, Typography } from "@mantine/core";
import { type PropsWithChildren, useState } from "react";
import { FormEditor } from "./FormEditor";

type PreviewFormEditorProps = PropsWithChildren<
  InputWrapperProps & {
    defaultValue?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onPreview: () => void;
    previewText?: string;
    disabled?: boolean;
  }
>;

export function PreviewFormEditor({
  defaultValue,
  onChange,
  onPreview,
  previewText,
  children,
  disabled = false,
  ...props
}: PreviewFormEditorProps) {
  const [activeTab, setActiveTab] = useState<string | null>(TabValue.WRITE);
  const onTabChange = (value: string | null) => {
    if (value === TabValue.PREVIEW) {
      onPreview();
    }
    setActiveTab(value);
  };

  return (
    <Input.Wrapper {...props}>
      <Tabs value={activeTab} onChange={onTabChange} variant="outline">
        <Tabs.List>
          <Tabs.Tab value={TabValue.WRITE}>Schreiben</Tabs.Tab>
          <Tabs.Tab value={TabValue.PREVIEW}>Vorschau</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value={TabValue.WRITE}>
          <FormEditor defaultValue={defaultValue} disabled={disabled} onChange={onChange} borderTop="none">
            {children}
          </FormEditor>
        </Tabs.Panel>
        <Tabs.Panel value={TabValue.PREVIEW}>
          <Paper withBorder p="lg" styles={{ root: { borderTop: "none" } }}>
            {previewText ? (
              <Typography>
                {/* biome-ignore lint/security/noDangerouslySetInnerHtml: rich text contents */}
                <div dangerouslySetInnerHTML={{ __html: previewText }} />
              </Typography>
            ) : (
              <Center>
                <Loader size={32} />
              </Center>
            )}
          </Paper>
        </Tabs.Panel>
      </Tabs>
    </Input.Wrapper>
  );
}

enum TabValue {
  WRITE = "write",
  PREVIEW = "preview",
}
